module.exports = __webpack_public_path__ + "static/media/image_groupsale_large_gray.b910ee6b.png";